<template>
  <div class="main">
    <SearchField :form="formInline" :formCtrl="formCtrl" @onSearch="onSearch" @onReset="onReset"
      @onChange="onSearchItemChange">
      <!-- 复合搜索框 -->
      <template #beforeBtn>
        <CompositeFormCtrl ref="comFormCtrl" :options="searchKeyOptions" @onChange="onComSearchChange">
        </CompositeFormCtrl>
      </template>
      <!-- 导出按钮 -->
      <template #end>
        <el-form-item class="endBtn">
          <el-button type="primary" icon="el-icon-download" @click="Export(`合同运单_全部车辆`)">导出</el-button>
        </el-form-item>
      </template>
      <!-- 表头设置控件 -->
      <template #right>
        <TableHeadSelect :config="formCtrlRight" :options="formCtrlRight.options" :inputValue="defaultTh"
          @onChange="onTableSelect" />
      </template>
    </SearchField>

    <Table ref="table" :tableData="tableData" :cols="cols" :page="page" :limit="limit" :total="total" :showTotal="true"
      :getTotal="getTotal" @onSelectionChange="onSelectionChange" @onCurrentChange="onCurrentChange"
      @onSizeChange="onSizeChange">
      <template #btns="params">
        <Btn v-if="showEditBtn(params.params)" :config="btns[0]" :data="params.params" />
        <Btn v-if="!showEditBtn(params.params)" :config="btns[1]" :data="params.params" />
      </template>
    </Table>
  </div>
</template>

<script>
import tableMixin from "@/pages/mixin/table";
import mixin from "@/pages/orderManage/contract/own/mixin";

export default {
  mixins: [tableMixin, mixin],
  data() {
    return {
      baseUrl: 'order',
      formInline: {
        order_type: 2,
        ischeck: 0,
      },
      formCtrl: [
        {
          ...this.ctrls.ZhuangHuoRiQi,
          label: "装货日期：",
          placeholder: "选择日期",
        },
      ],
      curSearchKey: 'shname',
      curSearchValue: undefined,
      searchKeyOptions: [
        { label: '承运公司', value: 'pcustomname', },
        // { label: '客户名称', value: 'shname', },
        { label: '车牌号', value: 'license', },
      ],
      cols: [
        { keyName: "order_num", label: "运单编号", minwidth: 130 },
        { keyName: "license", label: "车牌号", minwidth: 120 },
        { keyName: "driver", label: "司机姓名", minwidth: 120 },
        { keyName: "name", label: "货物名称", minwidth: 120 },
        { keyName: "shname", label: "客户名称", minwidth: 150 },
        { keyName: "coaddress", label: "装货地址", minwidth: 120 },
        { keyName: "enaddress", label: "卸货地址", minwidth: 120 },
        { ...this.ctrls.ZhuangHuoRiQi, minwidth: 120 },
        { keyName: "inton", label: "装货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "unton", label: "卸货量", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "freight", label: "应收运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "infreight", label: "应付运费", align: 'right', className: 'pr30', minwidth: 120 },
        { keyName: "", label: "操作", fixed: 'right', slot: 'btns', minwidth: 130 },
      ],
      btns: [
        {
          ...this.editBtn,
          cb: ({ id, ischeck }) => {
            // console.log(id)
            let path = `/order/contractdetail`
            if (this.$route.path === '/contract/orderlist/all') {
              path = '/contract/orderDetail1'
              if (ischeck == 2) {
                path = '/contract/orderDetail2'
              }
            }
            this.$router.push({
              path,
              query: {
                id,
                mode: 'edit',
              }
            });
          },
        },
        {
          ...this.viewBtn,
          cb: ({ id }) => {
            // console.log(id)
            let path = `/order/contractview4`
            if (this.$route.path.includes('/contract/orderlist')) {
              path = '/contract/orderview4'
            }
            this.$router.push({
              path,
              query: {
                id,
                mode: 'view',
              }
            });
          },
        },
      ],
      getTotalProperty: ['inton', 'unton', 'infreight', 'freight'],
    };
  },
  methods: {
    showEditBtn(a) {
      let boo = false
      const { user_group_id } = this.user
      const { ischeck, isstatus, isover, is_reject, isfleet } = a
      if (
        // 外协运单直接显示编辑
        ischeck == 2 || (
        // 司机
        user_group_id == 9 && (isstatus == 3 && isover == 1 || (is_reject == 1 && isover == 1) || isstatus == 2) ||
        // 队长
        (user_group_id == 5 && (isstatus == 3 && isover == 2 && isfleet == 1 || (isstatus == 3 && isover == 1) || [1, 2].includes(isstatus))) ||
        // 财务
        ([2, 3, 4].includes(user_group_id) && isstatus == 3 && isover == 2 && isfleet == 2) ||
        // 超管
        user_group_id == 1)
      ) {
        boo = true
      }
      return boo
    },
  },
  created() {
    const { id } = this.$route.query
    // console.log('created', id)
    if (id) {
      // 如果页面带id参数，说明是合同跳转过来的，搜索时加上合同id
      this.formInline.contractid = id
      // this.searchKeyOptions = [
      //   { label: '车牌号', value: 'license', },
      // ]
      this.$nextTick(this.getList)
    }
  },
  mounted() {
  },
};
</script>
